import { cn, tv } from "@utils/tw"
import { defineBlock, EditableText } from "eddev/blocks"

export const meta: BlockMeta = {
  title: "Stat Item",
  icon: "star-filled",
}

export default defineBlock("content/stats", (props) => {
  return (
    <div className="border-l border-white/20 px-5 flex flex-col gap-10">
      <EditableText as="div" store="stat" placeholder="110%" className="type-title-m md:type-title-l" />
      <EditableText as="div" store="label" placeholder="110%" className="type-label-l text-white/60 text-balance" />
    </div>
  )
})
